import { useState } from "react";
import { css } from "@emotion/react";

import CastModal, { CastModalProps } from "./CastModal";

export type CastItemProps = Omit<CastModalProps, "open" | "close">;

const CastItem: React.FC<CastItemProps> = (props) => {
  const { imgPath, castImgPath, castImgSize, castImgSizeSP } = props;
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div css={contentsWrapperStyle}>
        <div css={castImgWrapperStyle} onClick={() => setOpen(true)}>
          <img
            src={process.env.REACT_APP_BASE_PATH + imgPath}
            css={castImgStyle}
          />
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/cast-btn.png"}
            onClick={() => setOpen(true)}
            css={openBtnStyle}
          />
        </div>
        <img
          src={process.env.REACT_APP_BASE_PATH + castImgPath}
          css={castNameImgStyle(castImgSize, castImgSizeSP)}
        />
      </div>
      <CastModal open={open} close={() => setOpen(false)} {...props} />
    </div>
  );
};

const spSize = 768;

const contentsWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const castImgWrapperStyle = css`
  position: relative;
  width: 350px;
  overflow: hidden;

  @media (max-width: ${spSize}px) {
    width: 240px;
  }

  &:hover {
    cursor: pointer;
  }
`;

const castImgStyle = css`
  width: 100%;
  height: auto;
`;

const castNameImgStyle = (width: number, widthSP: number) => css`
  margin-top: 12px;
  width: ${width}px;

  @media (max-width: ${spSize}px) {
    width: ${widthSP}px;
  }
`;

const openBtnStyle = css`
  position: absolute;
  right: 10px;
  bottom: 20px;
  width: 30px;
  height: auto;

  &:hover {
    cursor: pointer;
  }
`;

export default CastItem;
